import { css } from 'styled-components';
import { Spacing24 } from 'autogen/design-tokens/tokens';
import type { ConnectedContentProductDisplayModel } from 'autogen/swagger/all';
import ContentCard from 'components/ContentCard';
import type { ContentCardProps } from 'components/ContentCard/types';
import { mapResponsiveImageModelToImageProps } from 'components/generic/Image/helpers/mapToImageProps';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import ConnectedContentSurveyItem from 'components/surveySystem/components/ConnectedContentSurveyItem';
import { stringToKey } from 'modules/helpers/strings';
import { breakpoint } from 'variables';

const scrollContainerCss = css`
    && {
        padding: 0 ${({ theme }) => theme.Spacing16};
        margin: 0 -${({ theme }) => theme.Spacing16};
        scroll-padding-inline-end: ${({ theme }) => theme.Spacing16};
        scroll-padding-inline-start: ${({ theme }) => theme.Spacing16};

        ${breakpoint.up('1025px')} {
            padding: 0;
            margin: 0;
        }
    }
`;

export interface IProductDisplayConnectedContent {
    model: ConnectedContentProductDisplayModel[];
}

function ProductDisplayConnectedContent(props: IProductDisplayConnectedContent) {
    const { model } = props;

    return (
        <DynamicItemCarousel
            gapSize={Spacing24}
            items={model}
            scrollContainerCss={scrollContainerCss}
            itemRenderer={(item: ConnectedContentProductDisplayModel, index) => {
                const { heading, layoutType } = item;
                const keySuffix = heading ? stringToKey(heading) : index;
                const { pageAction } = item.link || {};
                const isVideo =
                    pageAction?.action.$type === 'LiveEventCustomAction' ||
                    pageAction?.action.$type === 'VimeoCustomAction';
                const link: ContentCardProps['link'] | undefined = item.link?.pageAction
                    ? {
                          action: item.link?.pageAction,
                          label: item.link.linkText
                      }
                    : undefined;

                if (item.surveyQuestion) {
                    return (
                        <ConnectedContentSurveyItem
                            key={`${layoutType}_${keySuffix}`}
                            model={item}
                            type="ConnectedContentProductDisplay"
                        />
                    );
                }
                return (
                    <ContentCard
                        key={`${layoutType}_${keySuffix}`}
                        isTransparent
                        image={{
                            ...mapResponsiveImageModelToImageProps(item.image),
                            transformType: 'WidthScale',
                            aspectRatio: '1/1'
                        }}
                        link={link}
                        heading={item.heading}
                        subheading={item.layoutText}
                        showPlayIcon={isVideo}
                    />
                );
            }}
        />
    );
}

export default ProductDisplayConnectedContent;
